import React from 'react'
import { SVGIcon } from 'shared/ui'

const DeleteDraftButton = React.memo(props => {
  return (
    <SVGIcon
      name="updatedDelete"
      className={props.draftId ? 'deleteDraft active' : 'deleteDraft inactive'}
      {...props}
    />
  )
})

export default DeleteDraftButton
